import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import productsData from '../data/products.json';
import Product from '../components/Product';
const Products = () => {
    const [products, setProducts] = useState(productsData || []);
    const navigate = useNavigate();

    const showRangeDetails = (productId) => {
        navigate(`/product/${productId}`);
    }
    return (
        <>
            <div className='relative mb-1 md:mb-0'>
                <div className="md:block hidden">
                    <img
                        className="object-cover w-screen home-img"
                        src="/assets/static/images/Products-01.jpg"
                        alt=""
                    />
                </div>
                <div className="md:hidden block">
                    <img
                        className="object-cover w-screen landscape:hidden"
                        src="/assets/static/images/Products-01-sm.jpg"
                        alt=""
                    />
                    <img
                        className="object-cover w-screen portrait:hidden"
                        src="/assets/static/images/Products-01.jpg"
                        alt=""
                    />
                </div>
                <div className='absolute top-0 h-full md:hidden landscape:hidden block'>
                    <div className='relative h-full flex flex-col items-start pt-20 px-8 md:px-8 lg:px-20'>
                        <h1 className='lg:w-1/2 sm:w-3/4 w-full text-white' style={{ textShadow: '1px 1px #808080' }}>
                            Wide Range Of Products For Wider Smiles
                        </h1>
                        <p className='font--bold text-white pt-2 lg:pt-6 sm:w-3/4 leading-relaxed'>
                            Dinshaw’s offers a wide range of products from dairy to ice creams to bakery to namkeens; we ensure that your mornings & evenings are always ‘delectable’ & ‘delightful’.
                        </p>
                    </div>
                </div>
            </div>
            <div className='sm:grid sm:grid-cols-2 sm:gap-2 lg:block'>
                {
                    Object.keys(products).map((productId, index) => (
                        <Product key={index} data={products[productId]} showRangeDetails={showRangeDetails} productId={productId} index={index}></Product>
                    ))
                }
            </div>
        </>
    );
}

export default Products;